import { useEffect, useState } from 'react';
import api from '../utils/api';
import { buildRoleFeatureMatrix } from '../utils/permissions';

/**
 * Loads Settings → User Roles matrix for `canFeatureForRole` (same pattern as Teams / Matches).
 */
export function useRolePermissionMatrix() {
  const [rolePermissions, setRolePermissions] = useState({});
  const [permissionsReady, setPermissionsReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const loadRolePermissions = async () => {
      try {
        const response = await api.getPermissions();
        const permissionRows = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.data?.permissions)
          ? response.data.permissions
          : Array.isArray(response?.permissions)
          ? response.permissions
          : [];
        if (!cancelled) setRolePermissions(buildRoleFeatureMatrix(permissionRows));
      } catch (error) {
        console.error('Failed to load role permissions', error);
        if (!cancelled) setRolePermissions({});
      } finally {
        if (!cancelled) setPermissionsReady(true);
      }
    };

    loadRolePermissions();

    const onVisible = () => {
      if (document.visibilityState !== 'visible' || cancelled) return;
      loadRolePermissions();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return { rolePermissions, permissionsReady };
}
